module.exports = __webpack_public_path__ + "img/horizontal_6_5_pp3_8003.6e6254e1.png";